import store from '@/store'

import Vue from "vue"
// 用户权限指令
export default {
  async inserted(el, binding) {
    const { value } = binding
  
    if (value) {
      try {
        // 等待权限数据获取完成
        await store.dispatch('user/getUserAuthority')
        Vue.nextTick(() => {
          const hasPermission = store.state.user.authority.includes(value.toString())
         
          if (!hasPermission) {
            el.parentNode && el.parentNode.removeChild(el)
          }
        })
      } catch (error) {
        console.error('获取权限失败:', error)
        // 权限获取失败时默认移除元素
        el.parentNode && el.parentNode.removeChild(el)
      }
    }
  }
}

